'use client';

import { useState } from 'react';
import OfferCard from './OfferCard';
import PLPOfferCard from './PLPOfferCard';
import OfferDetails from './OfferDetails';
import type { OfferCardData } from './types';
import { useOptionalPaidLandingPageProvider } from '@/app/ready/[...slug]/PaidLandingPageProvider';
import { usePLPOfferCardViewModel } from './usePLPOfferCardViewModel';

interface StandaloneOfferCardProps {
  data: OfferCardData;
}

export default function StandaloneOfferCard({ data }: StandaloneOfferCardProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const plpContext = useOptionalPaidLandingPageProvider();
  const isPaidLandingPage = plpContext?.isPaidLandingPage ?? false;

  const plpOfferViewModel = usePLPOfferCardViewModel(data);

  const handleOpen = (_offer: OfferCardData) => {
    setIsDrawerOpen(true);
  };

  return (
    <>
      {isPaidLandingPage ? (
        <PLPOfferCard
          data={data}
          onOpen={handleOpen}
          {...plpOfferViewModel}
        />
      ) : (
        <OfferCard
          data={data}
          onOpen={handleOpen}
        />
      )}

      <OfferDetails
        data={data}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
}
